var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTibco = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_5_41)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18.3142 1.68562C17.9718 1.4752 17.6177 1.28427 17.2537 1.11375C14.2567 6.8625 8.81249 13.6988 1.60124 17.5875C2.00412 18.4962 2.53004 19.3451 3.16424 20.1105C9.36112 15.849 15.1001 8.72325 18.3157 1.6875M16.9815 0.994875C15.4995 0.34575 13.821 0 11.9989 0C5.25749 0 0.495741 5.20388 0.495741 12.054C0.492247 13.1514 0.611743 14.2457 0.851991 15.3165C7.74937 12.5055 13.8769 6.3075 16.9845 0.99075M18.5737 1.848C15.0375 10.5458 10.7257 16.7025 5.21849 21.9975C7.07924 23.2894 9.39449 24 12 24C18.7425 24 23.505 18.7605 23.505 11.9089C23.505 7.37137 21.6236 3.84712 18.573 1.84763",
  fill: "#1287D9"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_5_41"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  rx: 3,
  fill: "white"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgTibco);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/tibco.8b89a51978328e75e5fe91d087aa7b8d.svg";